export function refreshYotpoWidgets() {
    if (window.yotpoWidgetsContainer?.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
    }
    else {
        console.warn("Unable to update yotpo widgets; global Yotpo variables not defined");
    }
}
